<template>
  <div>
    <h1>{{ $t("delegationRate.title") }}</h1>
    <delegation-info-menu></delegation-info-menu>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3" v-if="hasPermissionForEdit">
        <v-btn v-on:click="addNewTask" color="accent" block dark class="mb-2">{{ $t("delegationRate.newRate") }}</v-btn>
      </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="items" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.country_symbol }}</td>
          <td class="text-left">{{ props.item.region }}</td>
          <td class="text-left">{{ props.item.currency }}</td>
          <td class="text-left">{{ props.item.amount }}</td>
          <td class="text-left">{{ props.item.hotel_limit }}</td>
          <td class="text-left">
            {{ props.item.group != null ? props.item.group.name : $t("delegationRate.basic") }}
          </td>
          <td class="justify-center layout px-0 datatable-action-column-field">
            <div v-if="hasPermissionForEdit">
              <v-btn icon class="mx-0" @click="editItem(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DelegationInfoMenu from "../../components/DelegationInfoMenu.vue";

export default {
  name: "DelegationInfoDelegationRateView",
  components: { DelegationInfoMenu },
  data: () => ({
    search: "",
    items: []
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("delegationRate.headers.country"),
          value: "country_symbol"
        },
        { text: this.$t("delegationRate.headers.region"), value: "region" },
        { text: this.$t("delegationRate.headers.currency"), value: "currency" },
        { text: this.$t("delegationRate.headers.dietLimit"), value: "amount" },
        {
          text: this.$t("delegationRate.headers.accommodationLimit"),
          value: "hotel_limit"
        },
        { text: this.$t("delegationRate.headers.group"), value: "group_id" }
      ];
    },
    hasPermissionForEdit() {
      return false;
    }
  },
  created() {
    const self = this;
    this.axios.get("delegation-rate/list").then(result => {
      self.items = result.data;
    });
  }
};
</script>

<style scoped></style>
